import React, { useState } from "react";
import { Link } from "react-router-dom";
import logo from "../assets/images/logo.png";
import { HashLink } from 'react-router-hash-link';

const Navigation = () => {
  const [isOpen, setIsOpen] = useState(false);

  const handleToggle = () => {
    setIsOpen(!isOpen);
  };

  return (
    <nav id="menu" className="navbar navbar-default navbar-fixed-top">
      <div className="container">
        <div className="navbar-header">
          <button
            type="button"
            className="navbar-toggle collapsed"
            onClick={handleToggle}
          >
            <span className="sr-only">Toggle navigation</span>
            <span className="icon-bar"></span>
            <span className="icon-bar"></span>
            <span className="icon-bar"></span>
          </button>
          <Link className="navbar-brand page-scroll" to="/">
            <img
              src={logo}
              alt="Logo"
              style={{
                height: "8rem",
                width: "13rem",
              }}
            />
          </Link>
        </div>

        <div
          className={`navbar-collapse ${isOpen ? 'in' : 'collapse'}`}
          id="bs-example-navbar-collapse-1"
        >
          <ul className="nav navbar-nav navbar-right">
            <li><HashLink smooth to="/#header" className="page-scroll" onClick={()=>setIsOpen(false)}>Home</HashLink></li>
            <li><HashLink smooth to="/#features" className="page-scroll" onClick={()=>setIsOpen(false)}>Courses</HashLink></li>
            <li><HashLink smooth to="/#about" className="page-scroll" onClick={()=>setIsOpen(false)}>About us</HashLink></li>
            <li><HashLink smooth to="/#portfolio" className="page-scroll" onClick={()=>setIsOpen(false)}>Gallery</HashLink></li>
            <li><HashLink smooth to="/#form" className="page-scroll" onClick={()=>setIsOpen(false)}>Form</HashLink></li>
            <li><HashLink smooth to="/#contact" className="page-scroll" onClick={()=>setIsOpen(false)}>Contact Us</HashLink></li>
            <li><Link to="/verify" className="page-scroll" onClick={()=>setIsOpen(false)}>Verification</Link></li>
            <li><Link to="/center-login" className="page-scroll" onClick={()=>setIsOpen(false)}>Center Login</Link></li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;
